import { create } from "zustand"

type AddProjectTypeDialogState = {
  isOpen: boolean
}

type AddProjectTypeDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useAddProjectTypeDialog = create<
  AddProjectTypeDialogState & AddProjectTypeDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useAddProjectTypeDialog
